<div class="row">
  <app-headertext text="Admin - Varslinger"></app-headertext>
  <div class="fill-space"></div>
</div>
<div>
  <div class="row child-margin">
    <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
    <div class="child-margin">
      <mat-card>
        <mat-card-header>
          <div mat-card-avatar>
            <mat-icon style="font-size: 30px; padding: 4px">ad_units</mat-icon>
          </div>
          <mat-card-title>Copy objects to RTDB</mat-card-title>
          <mat-card-subtitle>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>

          <form [formGroup]="objectsToRTDBForm">
            <div class="row">
              <mat-form-field>
                <input
                  matInput
                  #objectsToRTDB
                  type="text"
                  placeholder="Prosjekt ID"
                  formControlName="objectsToRTDB">
                <mat-error *ngIf="objectsToRTDB.form.invalid && objectsToRTDB.form.touched">
                  <div *ngIf="objectsToRTDB.form.errors.required">Prosjekt ID er <strong>obligatorisk</strong>
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <button mat-raised-button (click)="onObjectsToRTDBClick(objectsToRTDB.value)"
                    [disabled]="objectsToRTDB.value.length === 0" cdkFocusInitial>
              Oppdater RTDB med objekter
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </div>
    <div *ngIf="!mobileQuery.matches" class="fill-space"></div>
  </div>
</div>
